import _ from "lodash";
import set from "@rill/set";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import BackArrowButton from "../../../parts/back-arrow-button";
import SettingsNav from "../../../parts/settings-nav";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";

module.exports = (app) => {
  app
    .get(
      "/gym-contract",
      set("heading", "Edit Gym Contract"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin", "Team Coach"]
        ),
      ({ res, locals }) => (res.body = <GymContract locals={locals} />)
    )

    .post(
      "/gym-contract",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body } = req;
        const { gymContract } = body;
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { pressCustomBranding = {} } = userToRequest;
        const newBody = {};

        newBody.pressCustomBranding = Object.assign({}, pressCustomBranding);
        newBody.pressCustomBranding.gymContract = gymContract;

        try {
          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "Gym contract updated successfully.");
        } catch (e) {
          flash("error", e.message);
        }

        res.redirect("/coaching-portal/settings/gym-contract");
      }
    );
};

const GymContract = ({ locals }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  const { activeUser, organizationOwner, organizationRoleName } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { pressCustomBranding } = userToRequest;
  const initialState =
    !!pressCustomBranding && !!pressCustomBranding.gymContract
      ? pressCustomBranding.gymContract
      : "";
  const [contractFormState, setContractFormState] = useState(initialState);
  // Team Coach can view org settings but not change them — the server
  // already rejects the POST, this just keeps the save button from
  // silently failing.
  const isReadOnly = organizationRoleName === "Team Coach";

  /**
   * assign the value to the form
   * @param {*} param0
   */
  const handleInputChange = (event) => {
    const newState = event.target.value;
    setContractFormState(newState);
  };

  const handleDiscard = () => {
    setContractFormState(initialState);
  };

  return (
    <main className="settings gym-contract">
      <SettingsNav classNames="mobile-hidden" />

      <form
        id="form-gym-contract"
        method="POST"
        encType="multipart/form-data"
        data-noreset
      >
        <h3 className="mobile-hidden">{t("gymContract.title")}</h3>
        <SettingsBackHandler title={t("gymContract.title")} />

        {isReadOnly && (
          <p role="alert">{t("settingsNav.readOnlyTooltip")}</p>
        )}
        <section>
          <div role="input-group">
            <label>{t("gymContract.title")}</label>
            <textarea
              name="gymContract"
              placeholder={t("gymContract.placeholder")}
              value={contractFormState}
              onChange={handleInputChange}
              disabled={isReadOnly}
              sz="large"
            />
          </div>
        </section>
        <footer>
          <button
            data-button-type="secondary"
            data-action="cancel"
            type="button"
            onClick={handleDiscard}
          >
            {t("common:discard")}
          </button>
          <button
            data-button-type="primary"
            type="submit"
            disabled={isReadOnly}
          >
            {t("common:save")}
          </button>
        </footer>
      </form>
    </main>
  );
};
